module.exports = __webpack_public_path__ + "img/congrat.d9e6122a.png";